import { useState } from 'react';
import { Link } from '@compat/router';

import BuyButton from '@components/BuyButton';
import { Button, IconText, Picture } from '@ui';

import ConfirmModal from '@components/Modals/ConfirmModal';
import { useStores } from '@root/src/stores';
import useWindowSize from '@customHooks/useWindowSize';
import icons from '@icons';
import UIicons from '@ui-kit';
import { createImageErrorHandler } from '@utils/onImageError';
import { declension } from '@utils/declension';
import { observer } from 'mobx-react';
import './index.scss';

const { chevronDown, productCardErrorImg } = UIicons;
const {
  trash2: { black: trashOutlinedBlack, darkGrey: trashOutlinedGrey }
} = icons.Outline;
const onError = createImageErrorHandler(productCardErrorImg.x3);

const PurchaseTemplate = observer(
  ({
    item,
    addItemsToCartFromTemplateFunc,
    deleteTemplate,
    isShowItemsDefault
  }) => {
    const { isMobile, isTablet, isDesktop } = useWindowSize();
    const { modalsStore } = useStores();

    const [isShowItems, setIsShowItems] = useState(isShowItemsDefault);
    const [isConfirmModalOpened, setIsConfirmModalOpened] = useState(false);

    const toggleIsShowItems = () => setIsShowItems(prev => !prev);
    const openModal = () => setIsConfirmModalOpened(true);
    const onCloseModal = () => setIsConfirmModalOpened(false);
    const openQuickInfoModal = obj => modalsStore.openQuickInfo(obj.id);

    const sliceLength = isMobile ? 17 : item.title?.length;
    const title =
      item.title?.length >= 20
        ? item?.title?.slice(0, sliceLength).concat('...')
        : item.title;

    const onWrapperClick = (e, obj) => {
      if (isDesktop) {
        e.preventDefault();
        if (e.ctrlKey) {
          window.open(`/product/${obj.id}`, '_blank');
          return;
        }
        openQuickInfoModal(obj);
      }
    };

    return (
      <div className='purchase-template'>
        <div className='purchase-template__header'>
          <div className='purchase-template__name'> {title}</div>
          {isConfirmModalOpened && (
            <ConfirmModal
              title='Удалить список?'
              onClose={onCloseModal}
              open={isConfirmModalOpened}
              onConfirm={async () => {
                await deleteTemplate();
                setIsConfirmModalOpened(false);
              }}
            />
          )}
          <IconText
            onClick={openModal}
            withCursor
            height='24'
            fontSize='14'
            className='purchase-template__delete-btn'
            icon={trashOutlinedGrey.x3}
            iconHover={trashOutlinedBlack.x3}
            text='Удалить'
          />

          <Picture
            className={`purchase-template__hide-btn${
              isShowItems ? ' purchase-template__hide-btn--opened' : ''
            }`}
            onClick={toggleIsShowItems}
            icon={chevronDown}
            height='24'
            width='24'
          />
        </div>
        <div className='purchase-template__wrapper'>
          <div className='purchase-template__info'>
            <div className='purchase-template__total-goods'>
              {item.available.quantity}{' '}
              {declension(item.available.quantity, [
                ' товар',
                ' товара',
                ' товаров'
              ])}{' '}
              на <b>{item.available.amount} ₽</b>
            </div>
            <Button
              size='medium'
              rank='primary'
              text='Добавить все в корзину'
              onClick={addItemsToCartFromTemplateFunc}
            />
          </div>
          {item?.available?.list?.length ? (
            <>
              {isShowItems ? (
                <ul className='purchase-template__full-list'>
                  {item?.available?.list?.length &&
                    item.available.list.map(product => (
                      <li
                        key={product.catalog_id}
                        className='purchase-template__product'
                      >
                        <Link
                          onClick={e =>
                            onWrapperClick(e, { id: +product.catalogItem.id })
                          }
                          to={`/product/${product.catalog_id}`}
                          className='purchase-template__product__wrapper'
                        >
                          <div className='purchase-template__img-wrapper'>
                            <img
                              onError={onError}
                              src={
                                product?.catalogItem?.fileItem?.cacheItem[0]
                                  ?.filePath || productCardErrorImg.x3
                              }
                              alt={product.catalogItem.title}
                            />
                          </div>
                          <div>
                            <div className='purchase-template__product__title'>
                              {product.catalogItem.title}
                            </div>
                            <div className='purchase-template__product__vendor'>
                              артикул {product.catalogItem.id}
                            </div>
                          </div>
                        </Link>

                        <div className='purchase-template__product__quantity'>
                          {product.quantity}
                        </div>
                        <div className='purchase-template__product__price-btn'>
                          <div className='purchase-template__product__price-wrapper'>
                            <div className='purchase-template__product__price'>
                              {Math.round(
                                product.catalogItem.price * product.quantity
                              )}{' '}
                              ₽
                            </div>
                            <div className='purchase-template__product__sum'>
                              {product.quantity} × {product.catalogItem.price} ₽
                            </div>
                          </div>

                          <BuyButton
                            isWhite
                            className='buy-btn'
                            productId={product.catalogItem.id}
                            available={product.catalogItem.available}
                          />
                        </div>
                      </li>
                    ))}
                </ul>
              ) : (
                <div className='purchase-template__products-images'>
                  {item.available.list.map(
                    (product, ind) =>
                      (isMobile ? ind < 4 : isTablet ? ind < 12 : ind < 15) && (
                        <Link
                          key={product.id}
                          to={`/product/${product.catalogItem.id}`}
                        >
                          <img
                            alt={product.catalogItem.title}
                            onError={onError}
                            className='purchase-template__product-image'
                            src={
                              product?.catalogItem?.fileItem?.cacheItem[0]
                                ?.filePath || productCardErrorImg.x3
                            }
                          />
                        </Link>
                      )
                  )}
                </div>
              )}
            </>
          ) : null}
        </div>
      </div>
    );
  }
);

export default PurchaseTemplate;
